import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { RadioButton } from "primereact/radiobutton";
import { Chart } from "primereact/chart";
import { useSelector, useDispatch } from 'react-redux';
import * as jobConstants from "../../enums/jobs";
import moment from "moment";

import {
  setFilterReportType,
  fetchCustomReportData,
} from "./reportSlice";

export const CustomAverageVolumnExpendedView = () => {
  const navigate = useNavigate();
  const [chartData, setChartData] = useState({});
  const [chartOptions, setChartOptions] = useState({});

  const protrackReports = useSelector((state) => state.reports);
  const jobState = useSelector((state) => state.job);
  const {
    userId,
    clientId,
    appLanguage,
  } = jobState;
  const {
    customReportList,
    customPackVolumnReportList,
    reportStartDate,
    reportEndDate,
    filterChannelType,
    filterDocType,
    tabViewType,
    filterReportType,
  } = protrackReports;
  const categories = jobConstants.REPORT_FILTER_TYPE;
  const dispatch = useDispatch();

  useEffect(() => {
    const dayOrder = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    let avgPackVol = customReportList?.AvgPAckVolume ? customReportList?.AvgPAckVolume : [];
    const sortedAvgPackVolume = [...avgPackVol]
      .sort((a, b) => dayOrder.indexOf(a.day1) - dayOrder.indexOf(b.day1))
      .map(item => ({
        ...item,
        day1: filterReportType === 0 ? item.day1.slice(3, 5) : filterReportType === 1 ? item.day1.slice(0, 3) : item.day1.slice(0, 4)
      }));

    const documentStyle = getComputedStyle(document.documentElement);
    const textColor = documentStyle.getPropertyValue("--text-color");
    const textColorSecondary = documentStyle.getPropertyValue(
      "--text-color-secondary"
    );
    const surfaceBorder = documentStyle.getPropertyValue("--surface-border");
    const data = {
      labels: sortedAvgPackVolume.map(item => item.day1),
      datasets: [
        {
          type: "bar",
          label: "C5",
          backgroundColor: '#BFBFBF',
          data: sortedAvgPackVolume.map(item => item.AvgC5PackSize),
        },
        {
          type: "bar",
          label: "C4",
          backgroundColor: '#7F7F7F',
          data: sortedAvgPackVolume.map(item => item.AvgC4PackSize),
        }, {
          type: "bar",
          label: appLanguage["report.custom.label.toltip-others"],
          backgroundColor: '#C00000',
          data: sortedAvgPackVolume.map(item => item.AvgOtherPackSize),
        },
      ],
    };
    const options = {
      maintainAspectRatio: false,
      aspectRatio: 1,
      plugins: {
        tooltips: {
          mode: "index",
          intersect: false,
        },
        legend: {
          display: false
        },

        // legend: {
        //   display: false 
        // },
        // legend: {
        //   labels: {
        //     color: textColor,
        //   },
        // },
        legend: {
          display: true,
          position: 'bottom',
          labels: {
            color: textColor,
            // usePointStyle: true,
            padding: 20
          },
        },
      },
      scales: {
        x: {
          stacked: true,
          ticks: {
            color: textColorSecondary,
          },
          grid: {
            color: surfaceBorder,
            display: false,
          },
        },
        y: {
          stacked: true,
          ticks: {
            color: textColorSecondary,
          },
          grid: {
            color: surfaceBorder,
          },
        },
      },
    };
    setChartData(data);
    setChartOptions(options);
  }, [customReportList, appLanguage]);

  // For radio button

  const changeReportType = (e) => {
    dispatch(setFilterReportType(e.value));
    let filterParams = {
      clientId: clientId,
      userId: userId,
      typeId: tabViewType,
      channelType: filterChannelType.join("|"),
      filterType: filterDocType,
      fromDate: moment(reportStartDate).format("YYYY-MM-DD"),
      toDate: moment(reportEndDate).format("YYYY-MM-DD"),
      reportType: e.value,
    };
    dispatch(fetchCustomReportData(filterParams));
  }

  const downloadCustomPackVolumnReport = () => {
    downloadCsv(customPackVolumnReportList, 'custom_pack_volume_report.csv');
  }

  // Convert JSON to CSV
  const jsonToCsv = (jsonData) => {
    const isArray = Array.isArray(jsonData);
    if (isArray) {
      const headers = Object.keys(jsonData[0]);
      const csvRows = [];
      csvRows.push(headers.join(','));
      jsonData.forEach(item => {
        const values = headers.map(header => {
          const value = item[header];
          return `"${value !== null && value !== undefined ? value.toString().replace(/"/g, '""') : ''}"`;
        });
        csvRows.push(values.join(','));
      });
      return csvRows.join('\n');
    } else {
      const headers = Object.keys(jsonData);
      const values = headers.map(header => {
        const value = jsonData[header];
        return `"${value !== null && value !== undefined ? value.toString().replace(/"/g, '""') : ''}"`;
      });
      return `${headers.join(',')}\n${values.join(',')}`;
    }
  };

  // Trigger CSV download
  const downloadCsv = (jsonData, fileName) => {
    const csvData = jsonToCsv(jsonData);
    console.log('CSV Data:', csvData);
    const blob = new Blob([csvData], { type: 'text/csv' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    link.click();
  };

  return (
    <div className="comms-sla-met-wrapper">
      <div className="comms-sla-met-inner-wrap">
        <div className="left-col box-white">
          <h3 style={{ marginLeft: '110px' }}>
            {appLanguage["report.custom.label.average-pack-volumn"]}
            <ul className="comms-sla-radio-box">
              {categories.map((category) => {
                return (
                  <li key={category.key}>
                    <label htmlFor={category.key}>{category.name}</label>
                    <RadioButton
                      inputId={category.key}
                      name={category.key}
                      value={category.key}
                      onChange={(e) => changeReportType(e)}
                      checked={
                        filterReportType === category.key
                      }
                    />
                  </li>
                );
              })}
            </ul>
          </h3>
          <div className="card" style={{ minWidth: '0px' }}>
            <Chart
              type="line"
              data={chartData}
              options={chartOptions}
              height={470}
            />
          </div>
        </div>
        <div className="right-col">
          <div className="applied-filter-box">
            <p className="title">Applied Filters</p>
            <p style={{ width: '100px' }}>{moment(reportStartDate).format("DD MMM YYYY")} – {moment(reportEndDate).format("DD MMM YYYY")}</p>
            <p>{filterChannelType == 0 ? 'DOCUMENT' : filterChannelType == 1 ? 'EMAIL' : filterChannelType == 2 ? 'SMS' : 'ALL'}</p>
            <p>{filterDocType === 1 ? 'BATCH' : filterDocType === 2 ? 'ADHOC' : 'ALL'}</p>
            <p>Batch</p>
          </div>
          <div className="comms-btn-wrapper">
            <button className="return-icon-comms" onClick={() => navigate("/reports")}>Return</button>
            <button className="download-icon-comms" onClick={downloadCustomPackVolumnReport}>Download</button>
          </div>
        </div>
      </div>
      {/* <hr className="expended-graph-footer-border" /> */}
    </div>
  );
};
